/** Superadmin debug output for one explorer variable (mirrors the backend `ExploreDiagnostics`). */
export interface ExplorerDiagnostics {
  variable: string;
  axis: 'primary' | 'secondary';
  /** The exact request body that was sent. */
  request: Record<string, unknown>;
  /** The Mongo pipeline that was executed. */
  pipeline: unknown[];
  stageCounts: { index: number; stage: string; count: number | null; error?: string }[];
  /** Set when the full pipeline failed. */
  error?: string;
  /** Every measurement of the project/type, with the points and non-null values it contributed. */
  measurements: { _id: string; name: string; rows: number; values: number }[];
}

export interface ExplorerDebugResponse {
  datasets: any[];
  diagnostics: ExplorerDiagnostics[];
}

export interface StageCountView {
  index: number;
  stage: string;
  count: number | null;
  /** Set for stages that failed to execute. */
  error?: string;
  /** Change versus the previous stage (null for the first). */
  delta: number | null;
  /** True when this stage removed rows. */
  dropped: boolean;
}

/** Adds the change in row count per stage so the stage that loses data stands out. */
export function withDeltas(counts: { index: number; stage: string; count: number | null; error?: string }[]): StageCountView[] {
  return counts.map((c, i) => {
    const prev = i === 0 ? null : counts[i - 1].count;
    const delta = c.count === null || prev === null ? null : c.count - prev;
    return { ...c, delta, dropped: delta !== null && delta < 0 };
  });
}
